import React from 'react';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-conectiva-navy text-white pt-16 pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">

          {/* Lado Esquerdo: Contato e Infos */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <span className="text-2xl font-bold tracking-tighter">
                CONNECTIVA<span className="text-conectiva-lime">.</span>
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Formando profissionais de excelência para cuidar do futuro. Venha fazer parte da revolução na saúde.
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-3 text-gray-300">
                <MapPin className="text-conectiva-lime" size={20} />
                <span>Rod, BR 408, 31, Lote 07 Quadra G, Loteamento Edhit de Moraes Coutinho, Nazaré da Mata – PE</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Phone className="text-conectiva-lime" size={20} />
                <span>(81 9.9637-3680</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Mail className="text-conectiva-lime" size={20} />
                <span>contato@escolaconectiva.com.br</span>
              </div>
            </div>

            <div className="flex gap-4 mt-8">
              <a href="https://www.instagram.com/connectivatec/" className="bg-white/10 p-2 rounded-full hover:bg-conectiva-lime hover:text-conectiva-navy transition">
                <Instagram size={20} />
              </a>
              {/* <a href="#" className="bg-white/10 p-2 rounded-full hover:bg-conectiva-lime hover:text-conectiva-navy transition">
                <Facebook size={20} />
              </a> */}
            </div>
          </div>

          {/* Lado Direito: Mapa (Google Maps Embed) */}
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10 h-[300px]">
            <iframe
              src="https://maps.google.com/maps?q=Rod,%20BR%20408,%2031,%20Lote%2007%20Quadra%20G,%20Loteamento%20Edhit%20de%20Moraes%20Coutinho,%20Nazar%C3%A9%20da%20Mata%20-%20PE&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-500">
          &copy; 2026 Escola Técnica Connectiva. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
}